import { Button, Dialog, DialogButtons, Modal, TrashIcon } from '@st/theme'
import { useProcess, useSelect } from '~/store'
import { selPaymentLinkDialog } from '../../st-folder-selectors'
import { InvoiceLinkFields } from './invoice-link'

export function PaymentLinkDialog() {
  const { send } = useProcess('stFolder')
  const dialog = useSelect('stFolder', selPaymentLinkDialog)
  if (!dialog) return null

  const close = () => send({ type: 'paymentLinkClosed' })

  return (
    <Modal isOpen={true} onClose={close}>
      <Dialog
        className="sm:max-w-lg"
        title={dialog.title}
        subtitle="Shown to the client as a View invoice step"
        buttons={
          <DialogButtons>
            <Button variant="subtle" onClick={close}>
              Cancel
            </Button>
            <Button
              variant="primary"
              disabled={!dialog.canSave}
              onClick={() => send({ type: 'paymentLinkSaved' })}
            >
              Save
            </Button>
          </DialogButtons>
        }
      >
        <InvoiceLinkFields
          draft={dialog}
          onEdit={(edit) => send({ type: 'paymentLinkEdited', edit })}
        >
          {dialog.canRemove && (
            <Button
              variant="icon"
              aria-label="Remove link"
              onClick={() => send({ type: 'paymentLinkRemoved' })}
            >
              <TrashIcon className="size-5 text-gray-500" />
            </Button>
          )}
        </InvoiceLinkFields>
      </Dialog>
    </Modal>
  )
}
